import Vue from 'vue'
import Vuex from 'vuex'
import App from './App.vue'
import VueRouter from 'vue-router'
import createPersistedState from "vuex-persistedstate"

import LandingLaboratory from './pages/LandingLaboratory/LandingLaboratory.vue'
import Payment from './pages/Payment/Payment.vue'

export const bus = new Vue();

Vue.config.productionTip = false;
Vue.use(VueRouter);
Vue.use(Vuex);

const store = new Vuex.Store({
    state: {
        order: {},
        analyticsLoaded: {
            vk: false,
            facebook: false,
            google: false,
            metrika: false,
            amplitude: false
        },
        analyticsLoadedDone: false,
        analyticsLandingParameter: null
    },
    mutations: {
        setOrder(state, order) {
            state.order.id = order.id;
            state.order.authToken = order.authToken;
        },
        setAnalyticsLandingParameter(state, parameter) {
            state.analyticsLandingParameter = parameter;
        },
        setAnalyticsLoaded(state, type) {
            state.analyticsLoaded[type] = true;

            state.analyticsLoadedDone = state.analyticsLoaded.vk && state.analyticsLoaded.facebook && state.analyticsLoaded.google && state.analyticsLoaded.metrika && state.analyticsLoaded.amplitude;
        },
    },
    plugins: [createPersistedState({paths: ['order']})],
});

const router = new VueRouter({
    mode: 'history',
    base: process.env.NODE_ENV === 'production' ? '/services/translater/' : '/',
    routes: [
        {
            path: '/laboratory/payment/:status',
            component: Payment,
            meta: {
                title: 'Оплата'
            }
        },
        {
            path: '/',
            component: LandingLaboratory,
            meta: {
                title: 'Переведем ваши анализы с врачебного языка на разговорный'
            }
        }
    ]
});

router.beforeEach((to, from, next) => {
    // This goes through the matched routes from last to first, finding the closest route with a title.
    // e.g., if we have `/some/deep/nested/route` and `/some`, `/deep`, and `/nested` have titles,
    // `/nested`'s will be chosen.
    const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);

    // Find the nearest route element with meta tags.
    const nearestWithMeta = to.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);

    const previousNearestWithMeta = from.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);

    // If a route with a title was found, set the document (page) title to that value.
    if (nearestWithTitle) {
        document.title = nearestWithTitle.meta.title;
    } else if (previousNearestWithMeta) {
        document.title = previousNearestWithMeta.meta.title;
    }

    // Remove any stale meta tags from the document using the key attribute we set below.
    Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(el => el.parentNode.removeChild(el));

    // Skip rendering meta tags if there are none.
    if (!nearestWithMeta) {
        return next();
    }

    // Turn the meta tag definitions into actual elements in the head.
    nearestWithMeta.meta.metaTags.map(tagDef => {
        const tag = document.createElement('meta');

        Object.keys(tagDef).forEach(key => {
            tag.setAttribute(key, tagDef[key]);
        });

        // We use this to track which meta tags we create so we don't interfere with other ones.
        tag.setAttribute('data-vue-router-controlled', '');

        return tag;
    })
    // Add the meta tags to the document head.
                   .forEach(tag => document.head.appendChild(tag));

    next();
});

new Vue({
  render: h => h(App),
  router,
  store: store
}).$mount('#app');
